// @[userId|username] 형식으로 변환 (전송 직전에만 사용)
// userList: [{ userId, username }]
// confirmedMap: Map<username, userId> (팝업에서 선택된 매핑)
export const enrichMentions = (text, userList, confirmedMap = new Map()) => {
    const userMap = new Map();
    (userList || []).forEach(u => {
        if (u.username && !userMap.has(u.username)) userMap.set(u.username, u.userId);
    });
    return text.replace(/@([a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ_]+)/g, (match, name) => {
        const uid = confirmedMap.get(name) || userMap.get(name);
        if (uid) return `@[${uid}|${name}]`;
        return match;
    });
};

// @[userId|username] → @username (표시용, 편집 시 사용)
export const stripMentionTags = (text) =>
    typeof text === 'string' ? text.replace(/@\[([^\]|]*)\|([^\]]*)\]/g, '@$2') : text;
